import {useDispatch, useSelector} from "react-redux";
import {api, LoginRequest} from "@core/api";
import {useLocation, useNavigate} from "react-router-dom";
import {useCallback, useState} from "react";
import {setAuth} from "@core/store/slices/authSlice";
import {showMessage} from "@core/store/slices/snackbarSlice";
import {translate} from "@util";
import {MobileLogin} from "./MobileLogin";
import {DesktopLogin} from "./DesktopLogin";
import {useDownBreakpoint} from "@hooks";
import {Selectors} from "@core/store/selectors";

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const tenant = useSelector(Selectors.tenant);
  const [login, {isLoading}] = api.useLazyLoginQuery();

  const [rememberMe, setRememberMe] = useState<boolean>(false);

  const doLogin = useCallback(
    async (request: LoginRequest, rememberMe: boolean) => {
      await login(request)
        .unwrap()
        .then(response => {
          localStorage.setItem("rememberMe", rememberMe ? "1" : "0");
          dispatch(setAuth(response));

          const redirect = (location.state as {from?: Location})?.from || {
            pathname: "/dashboard",
          };
          navigate(redirect);
        })
        .catch(() =>
          dispatch(
            showMessage({text: translate("error.401"), severity: "error"}),
          ),
        );
    },
    [dispatch, login],
  );

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    const request: LoginRequest = {
      username: data.get("username")?.toString() ?? "",
      password: data.get("password")?.toString() ?? "",
    };

    doLogin(request, rememberMe);
  };

  const isDownMd = useDownBreakpoint("sm");

  return (
    <>
      {isDownMd ? (
        <MobileLogin
          tenantImg={tenant?.img}
          tenantName={tenant?.name}
          loading={isLoading}
          rememberMe={rememberMe}
          onSubmit={handleSubmit}
          setRememberMe={setRememberMe}
        />
      ) : (
        <DesktopLogin
          tenantImg={tenant?.img}
          tenantName={tenant?.name}
          loading={isLoading}
          rememberMe={rememberMe}
          onSubmit={handleSubmit}
          setRememberMe={setRememberMe}
        />
      )}
    </>
  );
};

export {LoginPage};
